import { writable } from 'svelte/store'


const createModal = () => {
  /**
   * @type {{active: boolean, message: string, accept: () => void, cancel: false|(() => void), acceptText: string, cancelText: string }}
   */
  const defaultModal = { 
    active: false,
    message: '', 
    accept: () => { }, 
    cancel: () => { }, 
    acceptText: '', 
    cancelText: '' 
}
  const { subscribe, set } = writable(defaultModal)
  
  /**
   * Set the alert component
   * 
   * @param {Object} objectParam
   * @param {String} objectParam.message
   * @param {() => void} objectParam.accept
   * @param {(() => void)|false} [objectParam.cancel]
   * @param {String} [objectParam.acceptText]
   * @param {String} [objectParam.cancelText]
   */
  const newModal = ({ message = '', accept, cancel = false, acceptText = '', cancelText = '' }) =>
    set({ message, accept, cancel, acceptText, cancelText, active: true })
  
  const removeModal = () => set(defaultModal)
  
  return { newModal, removeModal, subscribe }
}

export const modalAccept = createModal()